import { jsx, jsxs } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ jsxs("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M11.5 2H15.5858L5.79291 11.7929L7.20712 13.2071L17 3.41424V7.5H19V0H11.5V2Z", fill: "currentColor" }),
  /* @__PURE__ */ jsx("path", { d: "M8 2H0V19H17V11.5H15V17H2V4H8V2Z", fill: "currentColor" })
] });
export default SvgExternalLink;
